import { Link } from "react-router-dom";
import { products } from "../data/products";

type ProductEvolutionBannerProps = {
  successorSlug: string;
  extraSuccessorSlug?: string;
};

export default function ProductEvolutionBanner({
  successorSlug,
  extraSuccessorSlug,
}: ProductEvolutionBannerProps) {
  const successor = products.find((p) => p.slug === successorSlug);
  const extraSuccessor = extraSuccessorSlug
    ? products.find((p) => p.slug === extraSuccessorSlug)
    : undefined;

  if (!successor) return null;

  return (
    <section className="product-evolution-banner" aria-label="Évolution de la gamme">
      <p>
        Ce modèle a évolué. Découvrez son remplaçant, le{" "}
        <Link to={`/produits/${successor.slug}`}>{successor.name}</Link> →
      </p>
      {extraSuccessor && (
        <p>
          Il existe également une variante à serrure électronique, le{" "}
          <Link to={`/produits/${extraSuccessor.slug}`}>
            {extraSuccessor.name}
          </Link>
          .
        </p>
      )}
      <p>
        <Link to="/produits">Découvrir toute la nouvelle gamme →</Link>
      </p>
    </section>
  );
}
